import asCurrency from './asCurrency';
import asPercent from './asPercent';

export default function (value) {
    if (!value) {
        return '';
    }

    if (value.percent !== undefined && value.percent !== null) {
        return asPercent(value);
    }

    return asCurrency(value);
}
